import Styles from './index.module.scss'
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import Service from "../../../service";

const ConfirmToPointModal = ({ onClose, selectNftNo, totalCount, convertType, successCallBack }) => {

  const handleSubmit = async () => {
    try {
      showLoading();
      const res = await Service.convertCollection({nftNo: selectNftNo});
      hideLoading();
      if (res.code !== '000000') throw res.msg;
      Toast.show({
        content: '转化成功',
        afterClose: successCallBack,
      });
    } catch (error) {
      hideLoading();
      Toast.show(error);
    }
  }

  return (
    <div className={Styles.modalContainer}>
      <div className={Styles.box}>
        <div className={Styles.title}>转化为{convertType === 1 ? '宝石' : '积分'}</div>
        <div className={Styles.content}>
          <div>确认将选中商品转化，获得{totalCount || 0}{convertType === 1 ? '宝石' : '积分'}？</div>
          <div>选择转化后视为放弃藏品权益</div>
        </div>
        <div className={Styles.btnBox}>
          <div className={Styles.btnItem}>
            <button className={Styles.cancelBtn} onClick={onClose}>取消</button>
          </div>
          <div className={Styles.columnDivide}/>
          <div className={Styles.btnItem}>
            <button className={Styles.confirmBtn} onClick={handleSubmit}>确认转化</button>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ConfirmToPointModal